import updateTestDateReducer from "./updateTestDateReducer";

const testDateReducers = {
    updateTestDate: updateTestDateReducer
};

export default testDateReducers;